import { defaultSettings } from 'widget/player-widget';


// This settings will set only for new widget installations
// old installations will use old settings
// IMPORTANT! Use it for overriding existed settings only
export default _.merge({}, defaultSettings, {
  numbers: {
    settingsVersion: 1,
  },
  booleans: {
    showChannelCategories: false,
  },
});



// WEBPACK FOOTER //
// ./src/shared/constants/default-settings-v1.js